import api from '@/api'
import utils from '@/utils'
import moment from 'moment';
const FileSaver = require('file-saver')
class PaymentAPI {
  async getAllPayouts(filters) {
    try {
      const query = utils.func.objectToQueryString(filters)
      let resp = await api.request('GET', '/api/v1/payments/outcome/all/data?' + query, true)
      if (resp.status === 200) {
        return resp.data
      }
      return {
        success: false
      }
    } catch (error) {
      return {
        success: false,
        message: error
      }
    }
  }
  async getPayouts(filter = {}) {
    try {
      const query = utils.func.objectToQueryString(filter)
      let resp = await api.request('GET', '/api/v1/payments/outcome?' + query, true)
      if (resp.status === 200) {
        return resp.data
      }
      return {
        success: false
      }
    } catch (error) {
      return {
        success: false,
        message: error
      }
    }
  }
  async getSummary(filter) {
    try {
      let resp = await api.request('GET', '/api/v1/payments/outcome/summary', true)
      if (resp.status === 200) {
        return resp.data
      }
      return {
        success: false
      }
    } catch (error) {
      return {
        success: false,
        message: error
      }
    }
  }
  async createPayout(payout) {
    try {
      let resp = await api.request('POST', '/api/v1/payments/outcome', true, payout)
      if (resp.status === 201) {
        return resp.data
      }
      return {
        success: false
      }
    } catch (error) {
      return {
        success: false,
        message: error
      }
    }
  }
  async getPaymentRecords(filter = {}) {
    try {
      const query = utils.func.objectToQueryString(filter)
      let resp = await api.request('GET', '/api/v1/payments/income?' + query, true)
      if (resp.status === 200) {
        return resp.data
      }
      return {
        success: false
      }
    } catch (error) {
      return {
        success: false,
        message: error
      }
    }
  }
  async deletePaymentRecords(id) {
    try {
      let resp = await api.request('DELETE', '/api/v1/payments/income/' + id, true)
      if (resp.status === 200) {
        return resp.data
      }
      return {
        success: false
      }
    } catch (error) {
      return {
        success: false,
        message: error
      }
    }
  }
  async importPaymentRecords(formdata) {
    try {
      let resp = await api.request('POST', '/api/v1/payments/income/import', true, formdata)
      if (resp.status === 200) {
        return resp.data
      }
      return {
        success: false
      }
    } catch (error) {
      return {
        success: false,
        message: error
      }
    }
  }
  async importPaymoutRecords(formdata) {
    try {
      let resp = await api.request('POST', '/api/v1/payments/outcome/import', true, formdata)
      if (resp.status === 200) {
        return resp.data
      }
      return {
        success: false
      }
    } catch (error) {
      return {
        success: false,
        message: error
      }
    }
  }
  async deletePayoutRecords(id) {
    try {
      let resp = await api.request('DELETE', '/api/v1/payments/outcome/' + id, true)
      if (resp.status === 200) {
        return resp.data
      }
      return {
        success: false
      }
    } catch (error) {
      return {
        success: false,
        message: error
      }
    }
  }
  async getPaymentOrReceiptSummary(filter) {
    try {
      let resp = await api.request('GET', '/api/v1/payments/income/summary', true)
      if (resp.status === 200) {
        return resp.data
      }
      return {
        success: false
      }
    } catch (error) {
      return {
        success: false,
        message: error
      }
    }
  }
  async createPaymentOrReceipt(payout) {
    try {
      let resp = await api.request('POST', '/api/v1/payments/income', true, payout)
      if (resp.status === 201) {
        return resp.data
      }
      return {
        success: false
      }
    } catch (error) {
      return {
        success: false,
        message: error
      }
    }
  }
  async updatePaymentOrReceipt(id, payout) {
    try {
      let resp = await api.request('PATCH', '/api/v1/payments/income/' + id, true, payout)
      if (resp.status === 200) {
        return resp.data
      }
      return {
        success: false
      }
    } catch (error) {
      return {
        success: false,
        message: error
      }
    }
  }
  async deletePreProcessingPayment(id) {
    try {
      let resp = await api.request('POST', '/api/v1/payments/pre-processing-payments/delete-by/id', true, {data: [{id}]})
      if (resp.status === 200) {
        return resp.data
      }
      return {
        success: false
      }
    } catch (error) {
      return {
        success: false,
        message: error
      }
    }
  }
  async updatePreProcessingPayment(data) {
    try {
      let resp = await api.request('POST', '/api/v1/payments/pre-processing-payments/update-by/id', true, {data})
      if (resp.status === 200) {
        return resp.data
      }
      return {
        success: false
      }
    } catch (error) {
      return {
        success: false,
        message: error
      }
    }
  }
  // Recalculate and persist the default pre-processing balance for one payment owner.
  // ims_payment_service is the single source of truth for committed-amount/rebalance math -
  // call this instead of computing the balance client-side and writing it back.
  async rebalancePreProcessingPayout(data) {
    try {
      let resp = await api.request('POST', '/api/v1/payments/pre-processing-payments/rebalance-by-owner', true, data)
      if (resp.status === 200) {
        return resp.data
      }
      return {
        success: false
      }
    } catch (error) {
      return {
        success: false,
        message: error
      }
    }
  }
  async deleteProcessingPayment(id) {
    try {
      let resp = await api.request('POST', '/api/v1/payments/finance-payments/delete-by/id', true, {data: [{id}]})
      if (resp.status === 200) {
        return resp.data
      }
      return {
        success: false
      }
    } catch (error) {
      return {
        success: false,
        message: error
      }
    }
  }
  async updateProcessingPayment(data) {
    try {
      let resp = await api.request('POST', '/api/v1/payments/finance-payments/update-by/id', true, {data})
      if (resp.status === 200) {
        return resp.data
      }
      return {
        success: false
      }
    } catch (error) {
      return {
        success: false,
        message: error
      }
    }
  }
  async deleteImportedPayment(id) {
    try {
      let resp = await api.request('POST', '/api/v1/payments/imported-payments/delete-by/id', true, {data: [{id}]})
      if (resp.status === 200) {
        return resp.data
      }
      return {
        success: false
      }
    } catch (error) {
      return {
        success: false,
        message: error
      }
    }
  }
  async updateImportedPayment(data) {
    try {
      let resp = await api.request('POST', '/api/v1/payments/imported-payments/update-by/id', true, {data})
      if (resp.status === 200) {
        return resp.data
      }
      return {
        success: false
      }
    } catch (error) {
      return {
        success: false,
        message: error
      }
    }
  }
  async uploadPaymentInvoices(type, id, files) {
    try {
      let formData = new FormData()
      for (let file of files) {
        formData.append('invoices', file)
      }
      let resp = await api.request('POST', `/api/v1/payments/payment-invoices/${type}/${id}`, true, formData)
      if (resp.status === 200) {
        return resp.data && resp.data.data ? resp.data.data : resp.data
      }
      return {
        success: false
      }
    } catch (error) {
      return {
        success: false,
        message: error
      }
    }
  }
  async deletePaymentInvoice(type, id, invoiceID) {
    try {
      let resp = await api.request('DELETE', `/api/v1/payments/payment-invoices/${type}/${id}/${invoiceID}`, true)
      if (resp.status === 200) {
        return resp.data && resp.data.data ? resp.data.data : resp.data
      }
      return {
        success: false
      }
    } catch (error) {
      return {
        success: false,
        message: error
      }
    }
  }
  async updatePayout(id, payout) {
    try {
      let resp = await api.request('PATCH', '/api/v1/payments/outcome/' + id, true, payout)
      if (resp.status === 200) {
        return resp.data
      }
      return {
        success: false
      }
    } catch (error) {
      return {
        success: false,
        message: error
      }
    }
  }
  async updatePayoutStatus(id, status) {
    try {
      let resp = await api.request('PATCH', '/api/v1/payments/outcome/' + id + '/status', true, status)
      if (resp.status === 200) {
        return resp.data
      }
      return {
        success: false
      }
    } catch (error) {
      return {
        success: false,
        message: error
      }
    }
  }
  downloadCogsEstimateRpt(filters) {
    return new Promise(function (resolve, reject) {
      api
        .download('/api/v1/payments/download/cogs-estimation-report', 'POST', {filters})
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          FileSaver.saveAs(blob, `COGS Estimation Report (${utils.func.formatCustomDate(moment(), 'DD MMM YYYY')}).xlsx`)
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  }
  downloadProfitSummaryRpt(campaigns) {
    return new Promise(function (resolve, reject) {
      api
        .download('/api/v1/payments/download/profit-summary-report', 'POST', {campaigns})
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          FileSaver.saveAs(blob, `Profit Summary Report (${utils.func.formatCustomDate(moment(), 'DD MMM YYYY')}).xlsx`)
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  }
}

export default new PaymentAPI();



// WEBPACK FOOTER //
// ./src/components/views/Finance/paymentAPIs.js